export default __webpack_public_path__ + "static/media/kd2.9bc925f1.JPG";